import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";
import siteConfig from "../config/siteConfig";
import ProductGrid from "./ProductGrid";

const editorialStories = [
  {
    id: 12,
    title: "Texture for every day",
    description: "Comfortable layers in easy colours, selected for repeat wear.",
    link: "/shop?category=Cardigans",
    linkLabel: "Discover cardigans",
    modifier: "portrait",
  },
  {
    id: 18,
    title: "Small knits, big adventures",
    description: "Easy natural layers made for movement, play and passing on.",
    link: "/shop?collection=kids",
    linkLabel: "Shop kids",
    modifier: "offset",
  },
  {
    id: 26,
    title: "Carry the everyday",
    description: "Tactile accessories knitted slowly from linen and cotton.",
    link: "/shop?collection=accessories",
    linkLabel: "Shop accessories",
    modifier: "landscape",
  },
  {
    id: 6,
    title: "In every season",
    description: "Breathable pieces with a little structure and a lot of life.",
    link: "/shop?collection=women&category=Bottoms",
    linkLabel: "Shop women",
    modifier: "small",
  },
];

const scrollToTop = () => {
  if (typeof window !== "undefined") {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
};

function Main() {
  const stories = editorialStories
    .map((story) => ({
      ...story,
      product: productData.find((product) => product.id === story.id),
    }))
    .filter((story) => story.product);

  const editorialIds = new Set(editorialStories.map((story) => story.id));
  const featuredProducts = productData
    .filter(
      (product) => product.isBestSeller && !editorialIds.has(product.id)
    )
    .slice(0, 4);

  return (
    <main className="home main">
      <section className="home-hero" aria-labelledby="home-hero-title">
        <img
          className="home-hero__image"
          src="/img/editorial/hero.jpg"
          alt="Everyday knitwear styled in soft natural light"
          loading="eager"
          decoding="async"
        />
        <div className="home-hero__content">
          <p className="home-hero__eyebrow">Selected in Hong Kong</p>
          <h1 className="home-hero__title" id="home-hero-title">
            Clothes to live in,
            <br />
            love and pass on.
          </h1>
          <Link
            className="home-hero__link"
            to="/shop?filter=new"
            onClick={scrollToTop}
          >
            Explore new pieces
          </Link>
        </div>
      </section>

      <section className="home-statement" aria-labelledby="home-statement-title">
        <p className="home-statement__eyebrow">The {siteConfig.brandName} way</p>
        <h2 className="home-statement__title" id="home-statement-title">
          Natural fibres. Local hands.
          <br />
          Made for years, not seasons.
        </h2>
        <p className="home-statement__copy">{siteConfig.description}</p>
        <Link className="home-statement__link" to="/about" onClick={scrollToTop}>
          Read our story
        </Link>
      </section>

      <section className="home-editorial" aria-labelledby="home-editorial-title">
        <header className="home-editorial__header">
          <p className="home-editorial__index">01 — Stories to wear</p>
          <h2 className="home-editorial__title" id="home-editorial-title">
            Everyday, considered
          </h2>
        </header>

        <div className="home-editorial__grid">
          {stories.map(({ product, ...story }, index) => (
            <article
              className={`home-editorial__story home-editorial__story--${story.modifier}`}
              key={story.id}
            >
              <Link
                className="home-editorial__image-link"
                to={story.link}
                onClick={scrollToTop}
                aria-label={story.linkLabel}
              >
                <img
                  className="home-editorial__image"
                  src={product.image || product.images?.[0]}
                  alt={`${product.name}, ${product.category.toLowerCase()} in natural fibres`}
                  loading={index === 0 ? "eager" : "lazy"}
                  decoding="async"
                />
              </Link>
              <div className="home-editorial__story-copy">
                <p className="home-editorial__story-index">
                  {String(index + 1).padStart(2, "0")}
                </p>
                <h3 className="home-editorial__story-title">{story.title}</h3>
                <p className="home-editorial__story-description">
                  {story.description}
                </p>
                <Link
                  className="home-editorial__story-link"
                  to={story.link}
                  onClick={scrollToTop}
                >
                  {story.linkLabel}
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="home-featured" aria-labelledby="home-featured-title">
        <header className="home-featured__header">
          <div>
            <p className="home-featured__eyebrow">Most loved</p>
            <h2 className="home-featured__title" id="home-featured-title">
              Familiar favourites
            </h2>
          </div>
          <Link
            className="home-featured__link"
            to="/shop?sort=featured"
            onClick={scrollToTop}
          >
            View all pieces
          </Link>
        </header>

        <ProductGrid
          products={featuredProducts}
          className="home-featured__grid"
          label="Most loved products"
        />
      </section>
    </main>
  );
}

export default Main;
